export function authSelectors(state) {
  return state.auth;
}